import { Component, Input, OnInit } from '@angular/core';
import { PagingModel } from '../models/paging-model';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss']
})
export class PagingComponent implements OnInit {

  @Input()
  paging: PagingModel;

  @Input()
  parentComponent: any;
  
  @Input()
  pageChangeFunction: (parent: any, args: number) => void;

  @Input()
  showPageLabel: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  gotToPage(page: number) {
    this.pageChangeFunction(this.parentComponent, page);
  }
}
